import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import './user-avatar.css';

const UserAvatar = ({
    className,
    imageUrl
}) => (
    <img
        className="userThumbnail"
        src={imageUrl}
    />
);

UserAvatar.propTypes = {
    className: PropTypes.string,
    imageUrl: PropTypes.string
};

export default UserAvatar;
